// Test-only UI controls may render ONLY on the Emergent preview host (or localhost
// for development). The production domain (nflpickhouse.com) must NEVER show them.
export function previewToolsEnabled() {
  if (typeof window === "undefined" || !window.location) return false;
  const host = window.location.hostname || "";
  return host.endsWith(".preview.emergentagent.com") || host === "localhost" || host === "127.0.0.1";
}
